import React from 'react'
import { BaseView } from '@/components/base'
import { AppIcons } from '@/components/AppIcons'
import { useTheme } from '@/hooks/useTheme'

interface ScrollToTopButtonProps {
  visible: boolean
  onPress: () => void
}
export const ScrollToTopButton: React.FC<ScrollToTopButtonProps> = ({
  visible,
  onPress,
}) => {
  const theme = useTheme()

  if (!visible) return null

  return (
    <BaseView
      data-component="scroll-to-top-button"
      style={{
        position: 'fixed',
        bottom: '19px',
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        pointerEvents: 'none',
      }}
    >
      <BaseView
        circle
        circleSize={40}
        center
        style={{
          backgroundColor: theme.colors.background.semiTransparent,
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          pointerEvents: 'auto',
        }}
        onClick={onPress}
      >
        <AppIcons name="doubleChevronUp" size={32} color="label.default" />
      </BaseView>
    </BaseView>
  )
}
